import type { OzonetelHandlerName } from './sdk';
import type { CustomOztHandlerName } from './shared';

export const OZT_CALLBACK_TYPES = {
  onSipRegistered: 'ozt_onSipRegistered',
  onSipDisconnected: 'ozt_onSipDisconnected',
  onDropCall: 'ozt_onDropCall',
  onAgentRelease: 'ozt_onAgentRelease',
  onAgentCallAnswered: 'ozt_onAgentCallAnswered',
  onNewCall: 'ozt_onNewCall',
  onTranscribeText: 'ozt_onTranscribeText',
  onCallDetails: 'ozt_onCallDetails',
  onCallRecording: 'ozt_onCallRecording',
} as const;

export type OztCallbackType = (typeof OZT_CALLBACK_TYPES)[keyof typeof OZT_CALLBACK_TYPES];

export type OztCallback = {
  [K in OztCallbackType]: { eventType: K; eventPayload: unknown };
}[OztCallbackType];

export const OZONE_TEL_HANDLER_CALLBACK_TYPES = {
  onDropCall: OZT_CALLBACK_TYPES.onDropCall,
  onAgentRelease: OZT_CALLBACK_TYPES.onAgentRelease,
  onAgentAnswered: OZT_CALLBACK_TYPES.onAgentCallAnswered,
  onNewCall: OZT_CALLBACK_TYPES.onNewCall,
  onTranscribeText: OZT_CALLBACK_TYPES.onTranscribeText,
  onCallDetails: OZT_CALLBACK_TYPES.onCallDetails,
  onCallRecording: OZT_CALLBACK_TYPES.onCallRecording,
} as const satisfies Record<OzonetelHandlerName | CustomOztHandlerName, OztCallbackType>;

export const toOztCallback = (eventType: OztCallbackType, eventPayload?: unknown): OztCallback => ({
  eventType,
  eventPayload,
});
